import _ from "underscore";

export default {
  signedIn() {
    return _.isString(this.getToken()) && this.getToken().length > 0;
  },

  signIn(token) {
    localStorage.setItem("apiToken", token);
    return true;
  },

  signOut() {
    localStorage.removeItem("apiToken");
    localStorage.removeItem("teamId");
    return true;
  },

  getToken() {
    return localStorage.getItem("apiToken");
  },

  teamId() {
    return localStorage.getItem("teamId");
  }
};
